import React from 'react';
import CommerceFeed from '../components/CommerceFeed';
import Navbar from '../components/Navbar';

export default function FeedPage() {
  return (
    <div className="min-h-screen bg-[hsl(var(--background))]">
      <Navbar />
      <main className="max-w-4xl mx-auto px-6 py-8">
        <h1 data-testid="feed-title" className="text-2xl font-bold mb-6">Live Commerce Feed</h1>
        <div className="rounded-xl border border-[hsl(var(--border))] bg-[hsl(var(--card))]/50 p-4">
          <CommerceFeed limit={100} />
        </div>
      </main>
    </div>
  );
}
